import React from "react";
import Banner from "./Banner";
import VideoSection from "./VideosSection";
import CaseStudiesSection from "./CaseStudiesSection";

const Home = () => {
  return (
    <>
      <Banner />
      <VideoSection />
      <CaseStudiesSection />
    </>
  );
};

export default Home;
